/* import __COLOCATED_TEMPLATE__ from './predicates-editor.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type AiAgentGuidelineService from 'embercom/services/ai-agent-guideline-service';
import { action } from '@ember/object';
//@ts-ignore no type declaration available for ember-copy
import { copy } from 'ember-copy';

export default class AiAgentEscalationPredicatesEditor extends Component {
  @service declare intl: IntlService;
  @service declare aiAgentGuidelineService: AiAgentGuidelineService;
  @service declare notificationsService: $TSFixMe;
  @service declare attributeService: $TSFixMe;
  @service declare appService: $TSFixMe;

  get logicalSwitcherItems() {
    return [
      {
        text: this.intl.t('users-and-companies.rules-editor.and'),
        value: 'and',
      },
      {
        text: this.intl.t('users-and-companies.rules-editor.or'),
        value: 'or',
      },
    ];
  }

  get predicateGroup() {
    return this.aiAgentGuidelineService.escalationPredicateGroup;
  }

  get hasUnsavedChanges() {
    return this.aiAgentGuidelineService.hasUnsavedEscalationChanges;
  }

  get isSaveDisabled() {
    return !this.hasUnsavedChanges;
  }

  get attributeGroupList() {
    // Include user, company, and conversation attributes for escalation rules
    let conversationAttributes = [
      ...this.attributeService.assignmentRulesMessageAttributesAsAttributes,
      ...this.attributeService.assigneeAttributes,
      ...this.attributeService.outboundSupportConversationAttributes,
      ...this.attributeService.nonArchivedConversationCustomAttributes,
    ];

    let attributeGroups = [
      {
        heading: this.intl.t('app.lib.reporting.custom.filter-headings.conversation-data'),
        attributes: conversationAttributes,
      },
      {
        heading: this.intl.t('messenger.predicates.person-data'),
        attributes: this.attributeService.filterableUserAttributesForMessaging,
      },
    ];

    if (this.appService.app.companiesActive) {
      attributeGroups.push({
        heading: this.intl.t('messenger.predicates.company-data'),
        attributes: this.attributeService.filterableCompanyAttributesForMessaging,
      });
    }

    // Add ticket attributes if available
    if (this.attributeService.ticketAttributesByType?.length > 0) {
      attributeGroups = attributeGroups.concat(this.attributeService.ticketAttributesByType);
    }

    return attributeGroups;
  }

  @action
  onPredicatesUpdate(predicates: any[]) {
    // Update the predicate group directly like workflows and conditional branches do
    if (this.predicateGroup) {
      this.predicateGroup.set('predicates', copy(predicates));

      // Mark predicates as changed
      this.aiAgentGuidelineService.markEscalationPredicatesAsChanged();
      this.aiAgentGuidelineService.sendPreviewSettingsUpdatedMessage();
    }
  }

  @action
  async saveEscalationRules() {
    try {
      // This will actually save the escalation predicates to the backend
      await this.aiAgentGuidelineService.saveEscalationPredicates();

      // Show success notification
      this.notificationsService.notifyConfirmation(
        this.intl.t('ai-agent.guidance.save-success-confirmation'),
      );
    } catch (e) {
      this.notificationsService.notifyResponseError(e);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Escalation::PredicatesEditor': typeof AiAgentEscalationPredicatesEditor;
  }
}
